export const SHORTCUT_KEYS = Array.from({ length: 12 }, (_, index) => `F${index + 1}`);
export const SHORTCUT_DEFAULTS = {
  F1: 'Produk (admin)', F2: 'Kasir / pencarian', F3: 'Pelanggan', F4: 'Keranjang',
  F5: 'Muat ulang browser', F6: 'Bawaan browser / perangkat', F7: 'Bawaan browser / perangkat',
  F8: 'Pembayaran', F9: 'Bawaan browser / perangkat', F10: 'Bawaan browser / perangkat',
  F11: 'Layar penuh browser', F12: 'Bawaan browser / perangkat',
};
export function shortcutBinding(event, settings, catalog) {
  if (!settings?.enabled || event.defaultPrevented || event.ctrlKey || event.altKey || event.metaKey || event.shiftKey
    || !SHORTCUT_KEYS.includes(event.key)) return null;
  const binding = settings.bindings.find(item => item.key === event.key);
  return binding && catalog.some(item => item.to === binding.to) ? binding : null;
}
export function shortcutCatalog(groups) {
  const items = [];
  const visit = item => item.children ? item.children.forEach(visit) : items.push({ to: item.to, label: item.label });
  groups.forEach(group => group.items.forEach(visit));
  if (items.some(item => item.to === '/stok?tab=opname')) {
    items.push({ to: '/stok?tab=opname&action=quick', label: 'Stok Opname Cepat' });
  }
  return [...new Map(items.map(item => [item.to, item])).values()];
}
export function shortcutTarget(event, settings, catalog, dialogOpen) {
  if (!settings?.enabled || dialogOpen || event.defaultPrevented || event.repeat || event.isComposing
    || event.ctrlKey || event.altKey || event.metaKey || event.shiftKey) return null;
  if (event.target?.closest?.('input, textarea, select, [contenteditable]:not([contenteditable="false"])')) return null;
  if (!SHORTCUT_KEYS.includes(event.key)) return null;
  return shortcutBinding(event, settings, catalog)?.to || null;
}
